module.exports = "﻿﻿<div class=\"row\" *ngFor=\"let category of categories\">\r\n    <mat-category-tree-item [category]=\"category\" (selectedChanged)=\"onSelectedChanged($event)\" *ngIf=\"category.show\" maxSelected=\"maxSelected\"></mat-category-tree-item>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/category.tree.view/mat.category.tree.root.html
// module id = 1438
// module chunks = 0